import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { AnimalModel } from 'src/app/modules/animals/models/animal.model';

@Component({
  selector: 'app-animal-labels',
  template: `
  @if (!animal.inStock || animal.adoptionBlocked || animal.syncWithWebsite || animal.sex || animal.castrated) {
    <div class="p-2 rounded-none rounded-b-lg border-t-1 border-(--p-primary-200) bg-(--p-primary-50) flex flex-wrap gap-2">
      @if (!animal.inStock) {
        <p-chip
          label="Bestand"
          icon="pi pi-times-circle text-red-600"
        />
      }
      @if (animal.adoptionBlocked) {
        <p-chip
          [label]="getAdoptionBlockedLabel(animal)"
          icon="pi pi-lock text-red-600"
        />
      }
      @if (animal.syncWithWebsite) {
        <p-chip
          label="Webseite"
          icon="pi pi-check text-green-600"
        />
      }
      @if (animal.sex) {
        <p-chip
          [label]="animal.sex | transloco"
          [icon]="
            animal.sex === 'male'
              ? 'pi pi-mars text-blue-600'
              : animal.sex === 'female'
              ? 'pi pi-venus text-pink-600'
              : 'pi pi-question text-gray-500'
          "
        />
      }
      @if (animal.castrated !== undefined && animal.castrated !== null) {
        <p-chip
          [label]="getCastratedLabel(animal)"
          [icon]="animal.castrated ? 'pi pi-check text-green-600' : 'pi pi-times text-red-600'"
        />
      }

    </div>
  }
  @else {
    <div class="min-h-[45px] rounded-none rounded-b-lg border-t-1 border-(--p-primary-200) flex gap-2"></div>
  }
`,
  styleUrls: ['./animal-labels.component.scss'],
  standalone: false
})
export class AnimalLabelsComponent {
  @Input() animal!: AnimalModel;

  constructor(
    private readonly _translateService: TranslocoService,
    private readonly datePipe: DatePipe
  ) {
  }

  /** `adoptionBlockedUntil === null` bei gesetzter Sperre heißt „bis auf Weiteres“. */
  getAdoptionBlockedLabel(animal: AnimalModel): string {
    const base = this._translateService.translate('animal.adoptionBlocked.label');

    if (!animal.adoptionBlockedUntil) {
      return `${base} (${this._translateService.translate('animalMedical.untilFurtherNotice')})`;
    }

    return `${base} (${this.datePipe.transform(animal.adoptionBlockedUntil, 'dd.MM.yyyy')})`;
  }

  getCastratedLabel(animal: any): string {
    if (!animal.castrated) {
      return this._translateService.translate('animal.castrated.notCastrated');
    }

    const base = this._translateService.translate('animal.castrated.castrated');

    if (animal.castratedDate) {
      const date = this.datePipe.transform(animal.castratedDate, 'dd.MM.yyyy');
      return `${base} (${date})`;
    }

    return base;
  }
}
